/*
 * @Descripttion:
 * @Author: zhongbin.chen
 * @Date: 2021-09-07 16:16:40
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-21 15:01:35
 */

export default {
	"route.dashboard": "数据报表",
	"route.robot": "机器人",
	"route.robotList": "机器人列表",
	"route.groupManage": "分组管理",
	"route.disinfect": "任务",
	"route.home": "首页",
	"route.disinfectTask": "任务",
	"route.building": "楼宇",
	"route.accessControl": "门禁",
	"route.ladderControl": "梯控",
	"route.IOT": "IOT",
	"route.accounts": "账号",
	"route.roles": "角色",
	"route.jurisdiction": "权限",
	"route.dispatcher": "配送员",
	"navbar.logOut": "退出登录",
	"login.title": "企业号登录",
	"login.logIn": "登录",
	"login.username": "账号",
	"login.tip_username": "请输入账号",
	"login.password": "密码",
	"login.company_id": "企业号",
	"login.tip_company": "请输入企业号",
	"login.tip_pwd": "请输入密码",
	"robot.projectTtitle": "机器人管理平台",
	"robot.manage": "机器人管理",
	"system.search": "搜索",
	"system.reset": "重置",
	"system.open": "展开",
	"system.retract": "收起",
	"system.status": "状态",
	"system.inProgress": "进行中",
	"system.normalCompletion": "完成",
	"system.abnormalEnd": "异常结束",
	"system.noData": "暂无数据",
	"universality.confirm": "确认",
	"universality.cancel": "取消",
	"universality.Pleasedonot": "请不要输入为空",
	"universality.Pleaseifsymbols": "请输入6-20位数字、英文、特殊符号",
	"disinfect.robotremarkname": "机器人备注名",
	"disinfect.EnterNoteName": "输入备注名",
	"disinfect.robotSerialNumber": "机器人序列号",
	"disinfect.inputSequenceNumber": "输入序列号",
	"disinfect.selectStatus": "选择状态",
	"disinfect.destination": "目的地",
	"disinfect.Enterdestination": "输入目的地",
	"disinfect.dates": "日期",
	"disinfect.tos": "至",
	"disinfect.startDates": "开始日期",
	"disinfect.endDates": "结束日期",
	"disinfect.starttimes": "开始时间",
	"disinfect.endtimes": "结束时间",
	"disinfect.Lastweek": "最近一周",
	"disinfect.Lastmonth": "最近一个月",
	"disinfect.Lastthreemonths": "最近三个月",
	"disinfect.nonExecution": "未执行",
	"disinfect.canceled": "取消",
	"disinfect.UnclaimedProperty": "无人取物",
	"disinfect.hardwareFailure": "硬件故障",
	"disinfect.NavigationFault": "导航故障",
	"disinfect.Manualcancellation": "手动取消",
	"navigationBar.logout": "退出登录",
	"navigationBar.logoutandsystem": "确认退出账号并登出系统吗？",
	"account.userlist": "账号列表",
	"account.searchnames": "搜索账号、姓名",
	"account.adduser": "添加账号",
	"account.user": "账号",
	"account.roles": "角色",
	"account.ResponsibleRobot": "负责机器人",
	"account.name": "姓名",
	"account.remark": "备注",
	"account.Recentloginiof": "最近登录信息",
	"account.operation": "操作",
	"account.compile": "编辑",
	"account.resetpasswords": "重置密码",
	"account.delete": "删除",
	"account.pleaseuserpasnumb": "6-20位英文，数字，特殊字符",
	"account.pleasepasswordnumb": "6-20位英文，数字，特殊字符",
	"account.selectroles": "选择角色",
	"account.selectbuild": "选择楼宇",
	"account.inputnames": "输入用户姓名",
	"account.inputremarks": "输入备注",
	"account.userdetail": "账号详情",
	"account.platform": "台",
	"account.noBindingRobot": "暂无绑定机器人",
	"account.addtimes": "添加时间",
	"account.LastonlineTime": "最近上线时间",
	"account.Resetsuccessfully": "重置成功",
	"account.initialPassword": "初始密码",
	"account.gotIt": "知道了",
	"account.PleaseRoles": "请选择角色",
	"account.Pleasebuilds": "请选择楼宇",
	"account.PleaseRobots": "请选择机器人",
	"account.compileusers": "编辑账号",
	"account.deleteusers": "删除账号",
	"account.Unabletologinafterdeleting": "删除账号无法登陆，确认删除吗？",
	"account.alreadyexistsConfirmpasswords": "确认将该账号密码重置为初始密码吗",
	"account.alreadyExists": "账号已存在",
	"map.deleteThecloudmap": "删除云端地图，将同步删除全部关联机器人的该地图，确认删除吗？",
	"map.deletemaps": "删除地图",
	"homes.robotTotal": "机器人总数（台）",
	"homes.tasksTotal": "累计任务总数（个）",
	"homes.onlineTimeTotal": "累计在线总时长",
	"homes.nearly-7-days-onlineTime": "近7天在线时长趋势",
	"homes.cumulativeMileage": "累计里程（米）",
	"homes.robotWorkingHoursData": "机器人工作时长数据",
	"homes.trendWorkingHours": "工作时长趋势",
	"homes.explain": "说明",
	"homes.explainContent": "统计机器人在不同楼宇中的配送数据",
	"homes.to": "至",
	"homes.startTime": "开始时间",
	"homes.endTime": "结束时间",
	"homes.proportionWorkingHours": "工作时长占比",
	"homes.buildingDeliveryList": "楼宇配送次数排行榜",
	"public.second": "次",
	"public.rice": "米",
	"public.lastSevenDays": "近7天",
	"public.lastFourteenDays": "近14天",
	"public.lastThirtyDays": "近30天",
	"robotState.notActive": "未激活",
	"robotState.abnormalEnd": "异常结束",
	"robotState.hasLeft": "已离开",
	"robotState.online": "在线",
	"robotState.offline": "离线",
	"robotState.charge": "充电",
	"robotState.unknown": "未知",
	"robotState.atWork": "工作中",
	"robotState.free": "空闲",
	"robotState.unexecuted": "未执行",
	"robotState.executing": "执行中",
	"robotState.canceled": "已取消",
	"robotState.Completed": "已完成",
	"robotState.nobodyTakesThings": "无人取物",
	"robot.robotList": "机器人列表",
	"robot.buildings": "所属楼宇",
	"robot.selectBuilding": "选择楼宇",
	"robot.search": "搜索备注名、序列号",
	"robot.notAddRobot": "没有添加或激活机器人",
	"robot.mileage": "累计里程",
	"robot.information": "基础信息",
	"robot.noteName": "备注名",
	"robot.model": "型号",
	"robot.onlineStatus": "在线状态",
	"robot.workingStatus": "工作状态",
	"robot.currentPower": "当前电量",
	"robot.serialNumber": "序列号",
	"robot.operationData": "运行数据",
	"robot.latestOnlineTime": "最近上线时间",
	"robot.cumulativeOnlineDuration": "累计在线时长",
	"robot.cumulativeDeliveryTimes": "累计配送次数",
	"robot.cumulative-delivery-time": "累计配送时长",
	"robot.cumulativeLeadTimes": "累计引领次数",
	"robot.cumulativeLeadTime": "累计引领时长",
	"robot.System-Hardware": "系统与硬件",
	"robot.systemVersion": "系统版本",
	"robot.hardwareStatus": "硬件状态",
	"robot.language": "系统语言",
	"robot.voice_pack": "语音包",
	"robot.box_model": "箱格",
	"robot.android_soft": "安卓软件",
	"robot.android_mirror": "安卓镜像",
	"robot.header_control": "头部控制板",
	"robot.under_panel_version": "底盘版本",
	"robot.under_mirror": "底盘镜像",
	"robot.under_master": "底盘主控",
	"robot.under_control": "底盘控制板",
	"robot.rgbd_up": "RGBD（上）",
	"robot.rgbd_down": "RGBD（下）",
	"robot.doorControlMotor": "门控电机",
	"robot.frontMountedCamera": "前装摄像头",
	"robot.overheadCamera": "顶视摄像头",
	"robot.infraredDetectionBox": "箱体红外检测",
	"robot.microphone": "麦克风",
	"robot.radar": "雷达",
	"robot.head-RGBD": "头部RGBD",
	"robot.bottom-RGBD": "底部RGBD",
	"robot.ultrasonicSensor": "超声传感器",
	"robot.IMU": "IMU",
	"robot.hubMotor": "轮毂电机",
	"robot.emergencyStopSwitch": "急停开关",
	"robot.horn": "喇叭",
	"robot.getFailed": "获取失败",
	"robot.normal": "正常",
	"robot.abnormal": "异常",
	"robot.cancel": "取消",
	"robot.confirm": "确认",
	"public.noteNameCannotBeEmpty": "备注名不能为空",
	"public.layer": "层",
	"public.door": "栋",
	"public.rename": "重命名",
	"public.delete": "删除",
	"robot.percentageTasksCompletedTotal": "任务累计完成占比",
	"robotState.workSuspension": "工作暂停",
	"buiding.buildingList": "楼宇列表",
	"buiding.add": "添加",
	"buiding.addFloors": "添加楼层",
	"buiding.pleaseCompleteBuidingsData": "请在左侧楼宇列表，完善楼宇数据吧！",
	"buiding.map": "地图",
	"buiding.source": "来源",
	"buiding.uploadTime": "上传时间",
	"buiding.pleaseRobotUploadMap": "请先在机器人端上传地图",
	"buiding.associatedBuildings": "关联楼宇",
	"buiding.robot": "机器人",
	"buiding.associatedRobot": "关联机器人",
	"buiding.associatedShop": "关联店铺",
	"buiding.type": "类型：",
	"buiding.pleaseType": "请选择类型",
	"buiding.buildingName": "楼栋名称",
	"buiding.pleaseBuildingName": "请输入楼栋名称",
	"buiding.shopName": "店铺名称",
	"buiding.pleaseShopName": "请输入店铺名称",
	"buiding.floor": "楼层：",
	"buiding.floorName": "楼层名称：",
	"buiding.pleaseFloorName": "楼层名称：",
	"buiding.floorNameBeEmpty": "楼层名称不能为空",
	"buiding.buid": "楼栋",
	"buiding.shop": "店铺",
	"buiding.serialNumberCannotBeEmpty": "序号不能为空",
	"buiding.buildingAdd": "添加楼宇",
	"buiding.pleaseBuilsdingName": "请输入楼宇名称",
	"buiding.buildingsNameBeEmpty": "楼宇名称不能为空",
	"buiding.AreYouSureToDeleteThisFloor": "确定删除该楼层吗？",
	"buiding.deleteFloor": "删除楼层",
	"buiding.AreYouSureToDeleteThisShop": "确定删除该店铺吗？",
	"buiding.deleteShop": "删除店铺",
	"buiding.AreYouSureToDeleteThisBuilding": "确定删除该楼宇吗？",
	"buiding.deleteBuilding": "删除楼宇",
	"buiding.editBuilding": "编辑楼宇",
	"buiding.editFloor": "编辑楼层",
	"buiding.editShop": "编辑店铺",
	"buiding.shopNameAlreadyExists": "店铺名称已存在",
	"buiding.shopAddSuccess": "店铺添加成功",
	"buiding.floorNameAlreadyExists": "楼层名称已存在",
	"buiding.floorAddSuccess": "楼层添加成功",
	"buiding.buildingNameAlreadyExists": "楼宇名称已存在",
	"buiding.buildingAddSuccess": "楼宇添加成功",
	"buiding.shopEditSuccess": "店铺编辑成功",
	"buiding.buildingEditSuccess": "楼宇编辑成功",
	"buiding.floorEditSuccess": "楼层编辑成功",
	"buiding.selectRobot": "选择机器人",
	"buiding.replacementBuildings": "更换楼宇",
	"role.rolelist": "角色列表",
	"role.addroles": "添加角色",
	"role.names": "名称",
	"role.Entername": "输入名称",
	"role.PleaseEntername": "请输入名称",
	"role.editroles": "编辑角色",
	"role.deleteroles": "删除角色",
	"role.Confirmdeletion": "删除的角色无法恢复，确认删除吗？",
	"role.nameAlreadyExists": "角色名称已存在",
	"navigationBar.personalInfo": "个人信息",
	"navigationBar.changePassword": "修改密码",
	"navigationBar.administrator": "管理员",
	"navigationBar.domesticConsumer": "普通用户",
	"navigationBar.originalPsd": "原始密码",
	"navigationBar.EnterOriginalPsd": "输入原始密码",
	"navigationBar.newPassword": "新密码",
	"navigationBar.confirmPassword": "确认密码",
	"navigationBar.EntertheNewPsdAga": "再次输入新密码",
	"navigationBar.TheOriPsdCannotEmpty": "原始密码不能为空",
	"navigationBar.TheNewPsdempty": "新密码不能为空",
	"navigationBar.PleEntertheNewPsdAga": "请再次输入新密码",
	"navigationBar.TheNewPasastheoldone": "新密码与旧密码一致",
	"navigationBar.Psdisinconsistentwith": "确认密码与新密码不一致",
	"navigationBar.modifySuccessfully": "修改成功",
	"accessControl.accessControlList": "门禁列表",
	"accessControl.floor": "所属楼层",
	"accessControl.accessControlAdd": "添加门禁",
	"accessControl.accessControlID": "门禁ID",
	"accessControl.selectAccessControlID": "选择门禁ID",
	"accessControl.accessControlID-Hint": "门禁服务确认，该客户已配置好的门禁ID",
	"accessControl.label": "备注名",
	"accessControl.pleaseLabel": "输入备注名",
	"accessControl.deleteAccessControl-Hint": "删除门禁将导致机器人无法执行跨自动门任务，确认删除吗？",
	"accessControl.deleteAccessControl": "删除门禁",
	"accessControl.editAccessControl": "编辑门禁",
	"accessControl.accessControlIdExists": "门禁ID已存在",
	"public.notAssociatedFloor": "未关联所属楼层",
	"public.notAssociatedBuilding": "未关联所属楼宇",
	"public.all": "全部",
	"public.rules.pleaseLabel": "请输入备注名",
	"dispatcher.dispatcherList": "配送员列表",
	"dispatcher.searchName": "搜索姓名",
	"buiding.deleteShopTips": "请先取消关联该店铺的全部资产（机器人/地图）",
	"buiding.deleteBuidingTips": "请先取消关联该楼宇的全部资产（机器人/地图）",
	"buiding.deleteFloorTips": "请先取消关联该楼层的全部资产（地图）",
	"ladderControl.ladderControlList": "梯控列表",
	"ladderControl.addLadderControl": "添加梯控",
	"ladderControl.grouping": "分组",
	"ladderControl.Buildings": "所属楼宇",
	"ladderControl.You-can-go-to-the-floor": "可前往楼层",
	"ladderControl.pleaseGoToBuilding": "请前往楼宇，关联梯控",
	"ladderControl.grouping-tips-1": "分组主要用于区别不同的呼梯点",
	"ladderControl.grouping-tips-2": "1、仅1台电梯或多台相同楼层的电梯，可用默认分组",
	"ladderControl.grouping-tips-3": "2、不同楼层、候梯厅的电梯，需分组区分",
	"public.common": "栋",
	"ladderControl.ladderControlID": "梯控ID",
	"ladderControl.selectLadderControlID": "选择梯控ID",
	"ladderControl.ladderControlID-tips": "请先和梯控/门禁服务确认，该客户已配置好的电梯ID",
	"ladderControl.groupingPlaceholder": "输入或选择分组（例如：高层电梯）",
	"ladderControl.deleteladderControl": "删除梯控",
	"ladderControl.deleteladderControl-tips": "删除梯控将导致机器人无法执行跨层任务，确认删除吗？",
	"ladderControl.ladderControlIdExists": "梯控ID已存在",
	"login.remTheNub": "记住密码",
	"login.oldPasswordError": "原始密码错误",
	"login.confirmAndNewParrword": "确认密码与新密码不一致",
	"robot.advertising": "广告宣传",
	"homes.buildingDeliveryTimes": "楼宇配送次数",
	"robot.detail": "机器人详情",
	"robot.robotModel": "机器人型号",
	"robot.header_control-2": "安卓电源板",
	"robot.under_mirror-2": "底盘镜像",
	"robot.under_master-2": "底盘主控",
	"robot.under_control-2": "底盘电源板",
	"robot.nav": "导航算法",
	"robot.up_rgbd": "上RGBD",
	"robot.down_rgbd": "下RGBD",
	"robot.camera": "顶视摄像头",
	"robot.ss": "正视摄像头",
	"robot.rgbd_top_depth": "上RGBD深度",
	"robot.rgbd_top_color": "上RGBD彩色",
	"robot.rgbd_bottom_depth": "下RGBD深度",
	"robot.rgbd_bottom_color": "下RGBD彩色",
	"robot.ultrasonic1": "左超声",
	"robot.ultrasonic2": "右超声",
	"robot.motor1": "左轮毂电机",
	"robot.motor2": "右轮毂电机",
	"robot.detection": "物体检测",
	"buiding.builNameAlreadyExists": "楼栋名称已存在",
	"robot.bindingSuccess": "绑定成功",
	"robot.notActive": "未激活",
	"robotinfo.logdown": "日志下载",
	"robotinfo.Logtype": "日志类型",
	"robotinfo.displayboard": "显示板",
	"robotinfo.maincontrolpanel": "主控板",
	"robotinfo.powerstrip": "电源板",
	"robotinfo.navigationdata": "导航数据",
	"robotinfo.Plethedate": "请选择日期",
	"robotinfo.Plethetime": "请选择时间",
	"robotinfo.acquire": "获取",
	"robotinfo.Packinglog": "正在打包日志",
	"robotinfo.Uploadinglogfiles": "正在上传日志文件",
	"robotinfo.Gettinguploadstatus": "正在获取上传状态",
	"robotinfo.acquiresuccess": "获取成功",
	"robotinfo.clicktodownload": "点击下载",
	"robotinfo.Plelogtype": "请选择日志类型",
	"robotinfo.Plestartdateandtime": "请选择开始日期和时间",
	"robotinfo.Pleanenddateandtime": "请选择结束日期和时间",
	"robotinfo.Nologtime": "该时间段没有日志",
	"robotinfo.logtaskispackagedpackged": "当前有正在打包或上传日志任务",
	"robotinfo.failtoget": "获取失败",
	"robotinfo.Failedtopackage1/2": "打包1/2失败",
	"robotinfo.Failedtopackage2/2": "打包2/2失败",
	"robotinfo.failtoupload": "上传失败",
	"public.unrelatedBuildings": "未关联楼宇",
	"buiding.sameFloorNumber": "该楼宇已存在相同的楼层号码",
	"navigationBar.pleaseEnterOriginalPsd": "请输入原始密码",
	"navigationBar.newpassword": "输入新密码（请输入6-20位数字、英文、符号）",
	"navigationBar.pleaseNewpassword": "请输入新密码",
	"login.nnterprise-number-error": "企业号错误",
	"home.Fullrobot": "全部机器人",
	"map.displaytext": "显示文字",
	"map.nonetext": "不显示文字",
	"robot.detection-1": "物体检测1",
	"robot.detection-2": "物体检测2",
	"robot.detection-3": "物体检测3",
	"robot.detection-4": "物体检测4",
	"robot.current_systemVersion": "当前版本",
	"robot.cumulativeTimes": "累计送餐次数",
	"robot.cumulativeTime": "累计送餐时长",
	"home.hour": "小时",
	"home.min": "分",
	"home.deliverytimes": "配送次数（次）",
	"login.actpaswdinco": "账号或密码错误",
	"login.enterpriseerror": "企业号错误",
	"home.numberofworkmachs": "工作机器人数",
	"home.workinghours": "工作时长",
	"login.account_expired": "账号身份已过期，请重新登录",
	"robot.CADEBOT_rankingList_tips": "目的地送餐次数排行榜",
	"robot.setLabel": "备注名设置成功",
	"homes.nearly-7-days-mileage": "近7天里程趋势",
	"robot.robotisofflineobtalogs": "机器人离线，无法获取日志",
	"buiding.buid-illustrate": "楼栋（适用于多层）",
	"buiding.shop-illustrate": "店铺（适用于单层）",
	"buiding.new-pleaseFloorName": "请输入楼层名称",
	"route.admage": "广告宣传",
	"route.asset": "素材管理",
	"route.ads": "广告发布",
	"route.adsDetail": "广告详情",
	"route.addAds": "添加广告",
	"route.editAds": "编辑广告",
	"ad.asset": "资源列表",
	"ad.freeSpace": "剩余空间",
	"ad.uploadAsset": "上传资源",
	"ad.filename": "文件名称",
	"ad.type": "类型",
	"ad.memory": "内存",
	"ad.video": "视频",
	"ad.image": "图片",
	"ad.uploadTime": "上传时间",
	"ad.uploadProgress": "上传进度",
	"ad.uploadSuccess": "上传成功",
	"ad.operation": "操作",
	"ad.check": "查看",
	"ad.delete": "删除",
	"ad.confirm": "确认",
	"ad.cancel": "取消",
	"ad.deleteSuccess": "删除成功",
	"ad.back": "返回",
	"ad.deleteAsset": "删除资源",
	"ad.deleteAssetWarningMessage": "删除的资源将无法恢复，确认删除吗？",
	"ad.extLimit": "仅支持上传JPG、PNG、MP4、AVI、MOV、WMV、RMVB格式的文件",
	"ad.sizeLimit": "单个文件不能超过 1GB",
	"ad.syncFail": "下载失败",
	"ad.syncComplete": "下载完成",
	"ad.downloadComplete": "正在配置",
	"ad.downloadWaiting": "未下载",
	"ad.name": "方案名称",
	"ad.playTime": "播放时段",
	"ad.materialNum": "素材数量",
	"ad.robotNum": "投放机器人数量",
	"ad.startTime": "发布时间",
	"ad.addSchema": "添加广告",
	"ad.copySchema": "复制方案",
	"ad.edit": "编辑",
	"ad.publish": "发布",
	"ad.deleteDraft": "删除方案",
	"ad.save": "保存",
	"ad.preview": "预览",
	"ad.setDefault": "立即使用",
	"ad.setDefaultPlease": "请设置是否默认",
	"ad.yes": "是",
	"ad.no": "否",
	"ad.deleteDraftWarningMessage": "确认删除方案吗？",
	"ad.draft": "未发布",
	"ad.schemaDetail": "方案详情",
	"ad.schemaContent": "方案内容",
	"ad.syncRecord": "同步记录",
	"ad.robotSn": "投放机器人",
	"ad.robotSelect": "选择机器人",
	"ad.nameInput": "输入方案名称",
	"ad.robotSelectPlease": "请选择机器人",
	"ad.nameInputPlease": "请输入方案名称",
	"ad.materialList": "素材列表",
	"ad.materialListDescriptions": "广告屏尺寸为1080*1920，拖拽卡片可以调整顺序",
	"ad.setting": "投放设置",
	"ad.period": "时段",
	"ad.allDay": "全天",
	"ad.someTime": "分时段",
	"ad.beginTime": "开始时间",
	"ad.endTime": "结束时间",
	"ad.materialLib": "素材库",
	"ad.materialNumber": "素材数量",
	"ad.removeScreen": "删除分屏",
	"ad.removeScreenConfirm": "确认删除分屏吗？",
	"ad.playTimeDuration": "播放时长",
	"ad.picturePlayTime": "图片播放时长",
	"ad.addPeriod": "添加时段",
	"ad.addPeriodLimit": "可添加6个不同的时段",
	"ad.totalTime": "总时长",
	"ad.saveSuccess": "保存成功",
	"ad.publishSuccess": "发布成功",
	"ad.addPeriodFail": "已有全天时段,不可添加",
	"ad.publishFail": "发布失败",
	"ad.playTimeNoEmpty": "播放时段不能为空",
	"ad.materialListNoEmpty": "素材列表分屏不能留空",
	"ad.robot": "机器人",
	"ad.robotOffline": "机器人离线",
	"ad.robotOfflineAndCanNotLaunch": "以下机器人离线，无法投放",
	"ad.robotUplineOrSaveDraft": "请操作机器人联网，或先将方案存为草稿",
	"ad.syncStatus": "机器人下载状态",
	"ad.reSync": "重新投放",
	"ad.goBackList": "返回列表",
	"ad.confirmPublish": "确认发布么？",
	"ad.robotOfflineToConfirmPublish": "以下机器人为离线状态，确认发布么？",
	"ad.addCancelConfirm": "返回后不保存当前内容，确认返回吗？",
	"ad.refresh": "刷新",
	"ad.publishTime": "发布时间",
	"ad.lastModifyTime": "最新修改时间",
	"ad.publisher": "发布人",
	"ad.editor": "修改人",
	"ad.timeOverlap": "播放时段不能重叠，请检查",
	"ad.endTimeMustLargerThanStartTime": "播放时段结束时间必须大于开始时间",
	"ad.cannotDeleteAssetUsed": "此素材已被引用，不可删除",
	"ad.deletePeriodWarningMessage": "确认删除时段吗？",
	"ad.complete": "完成",
	"ad.fail": "失败",
	"ad.nameInputIllegal": "方案名称不能包含特殊字符",
	"ad.nameDuplicate": "方案名称已存在",
	"ad.updateTime": "最新修改时间",
	"role.TherolesDeletingfails": "该角色绑定了账号，删除失败",
	"account.Changeofauthority": "权限变更",
	"account.ThepermisschgePleaseagain": "该账号权限已变更",
	"disinfect.Unknowncause": "未知原因",
	"robot.accumulatedTaskExecutionTimes": "累计执行任务次数",
	"home.minute": "分钟",
	"homes.Statisticstasks": "统计机器人在执行任务（工作中）的数据",
	"disinfect.Initilizati": "初始化失败",
	"disinfect.Failedtogetlocation": "获取位置失败",
	"disinfect.pointisoffthemap": "目标点在地图外",
	"disinfect.onastaticobstacle": "目标点在静态障碍物上",
	"disinfect.therearenoroadsonthestaticmap": "静态地图上没有路",
	"disinfect.Startingpointobstacle": "起点有障碍物",
	"disinfect.Lossoflocation": "定位丢失",
	"disinfect.Failedtolocatethelostlocalpath": "局部路径规划失败",
	"disinfect.Clifftriggercancellation": "悬崖触发取消",
	"disinfect.Emergencystoptriggerscancellation": "急停触发取消",
	"disinfect.Collisionbartriggercancel": "防撞条触发取消",
	"disinfect.overtime": "超时",
	"disinfect.Chargingpiledetectionfailed": "充电桩检测失败",
	"disinfect.Pilefailure": "上桩失败",
	"disinfect.GlobalpathplanningfailedProcedure": "全局路径规划失败",
	"disinfect.Slopetriggercancellation": "斜坡触发取消",
	"disinfect.NavigationrecoverybeProcedure": "导航恢复行为失败",
	"disinfect.Navigateoutnarrowchannel": "导航退出窄通道",
	"disinfect.Androidtasktimeout": "安卓任务超时",
	"disinfect.elsesa": "其他",
	"robot.historicaldelete": "此机器人的历史数据将被删除，确认删除么",
	"robot.delfaild": "删除失败",
	"robot.LoRa_ID": "LoRa ID",
	"robot.associatedSIMCard": "关联SIM卡",
	"robot.accumulatedUsageTraffic": "累计使用流量",
	"robot.trafficUsageMonth": "本月使用流量",
	"robot.newrgbd_bottom_depth": "下RGBD深度",
	"robot.batteryTest": "电池检测",
	"robot.Partial_information_update_failed": "部分信息更新失败",
	"robot.update_failed": "更新失败",
	"robot.update_robot_datasSuccess": "获取机器人最新数据成功",
	"ad.waitForDownload": "等待下载",
	"ad.startDownload": "开始下载",
	"ad.offLineAndCannotDownload": "设备离线，无法下载",
	"ad.syncing": "同步中...",
	"robot.robot_does_not_exist": "机器人不存在",
	"robot.robot_current_enterprise": "机器人已离开当前企业",
	"ad.notEnoughSpace": "企业素材空间不足，请及时清理文件",
	"ad.addAsset": "添加素材",
	"robot.batteryCommunication": "电池通讯",
	"disinfect.Thetargetpointisobstacle": "目标点在动态障碍物上",
	"disinfect.Therearenoroadsonadynamicmap": "动态地图上没有路",
	"robot.buildingRobotErrorTips_10019": "此店铺机器人数量达到上限16台，请更换楼宇（店铺）",
	"robot.buildingRobotErrorTips_10020": "生成LoraId出错",
	"map.VirtualWall": "虚拟墙",
	"map.tracks": "轨道",
	"map.Qrcode": "二维码",
	"map.regions": "区域",
	"map.anchorpoints": "定位点",
	"robot.noSearchResults": "没有搜索结果",
	"robot.accountInformationHasBeenModified": "账号信息已修改",
	"public.tips": "提示",
	"public.agreeWith": "同意",
	"public.iHaveReadAndAgree": "我已阅读并同意",
	"public.userAgreement": "用户协议",
	"public.gentle": "和",
	"public.privacyAgreement": "隐私政策",
	"public.pleaseAgreeFirst": "请先同意",
}
  